 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"component-Aside":"component-Aside","component-Card":"component-Card","component-CardDetails":"component-CardDetails","component-DropdownList~component-DropdownListSearch~component-setup-Step1~component-setup-Step2~comp~255f6546":"component-DropdownList~component-DropdownListSearch~component-setup-Step1~component-setup-Step2~comp~255f6546","view-Dashboard":"view-Dashboard","layout-ResponsiveLayout":"layout-ResponsiveLayout","view-DashboardResponsive":"view-DashboardResponsive","view-ExploreResponsive":"view-ExploreResponsive","view-QuestListBountyResponsive":"view-QuestListBountyResponsive","view-QuestListDevelopmentResponsive":"view-QuestListDevelopmentResponsive","view-QuestListInvestigationResponsive":"view-QuestListInvestigationResponsive","view-QuestListResponsive":"view-QuestListResponsive","component-DashboardNavigation":"component-DashboardNavigation","component-DropdownList":"component-DropdownList","component-DropdownListSearch":"component-DropdownListSearch","component-setup-Step1":"component-setup-Step1","component-setup-Step2":"component-setup-Step2","component-setup-Step3":"component-setup-Step3","component-setup-Step4":"component-setup-Step4","component-setup-Step5":"component-setup-Step5","component-HelloWorld":"component-HelloWorld","component-MultiselectSearch":"component-MultiselectSearch","component-QuestListItem":"component-QuestListItem","component-QuestLog":"component-QuestLog","component-QuestObjective":"component-QuestObjective","component-QuestReward":"component-QuestReward","component-RandomChart":"component-RandomChart","view-BadgeResponsive":"view-BadgeResponsive","view-LeaderboardResponsive":"view-LeaderboardResponsive","component-Tab":"component-Tab","component-Tabs":"component-Tabs","component-TimeLog":"component-TimeLog","component-setup-Navigation":"component-setup-Navigation","layout-DashboardLayout":"layout-DashboardLayout","layout-DashboardLayoutMenu":"layout-DashboardLayoutMenu","layout-DefaultLayout":"layout-DefaultLayout","view-About":"view-About","view-AchievementsResponsive":"view-AchievementsResponsive","view-CMSResponsive":"view-CMSResponsive","view-Home":"view-Home","view-Leaderboard":"view-Leaderboard","view-NewBoardResponsive":"view-NewBoardResponsive","view-NewCardResponsive":"view-NewCardResponsive","view-NewCategoryResponsive":"view-NewCategoryResponsive","view-NewPlayerResponsive":"view-NewPlayerResponsive","view-NewQuestResponsive":"view-NewQuestResponsive","view-PageNotFound":"view-PageNotFound","view-Profile":"view-Profile","view-ProfileResponsive":"view-ProfileResponsive","view-QuestDetailsResponsive":"view-QuestDetailsResponsive","view-Quests":"view-Quests","view-Settings":"view-Settings","view-SettingsResponsive":"view-SettingsResponsive","view-Setup":"view-Setup"}[chunkId]||chunkId) + "." + {"component-Aside":"4ba378d3","component-Card":"85d2a4f6","component-CardDetails":"20791b16","component-DropdownList~component-DropdownListSearch~component-setup-Step1~component-setup-Step2~comp~255f6546":"9fab2cee","view-Dashboard":"0601ca34","layout-ResponsiveLayout":"a7c14c8d","view-DashboardResponsive":"14fff169","view-ExploreResponsive":"0c675fd5","view-QuestListBountyResponsive":"7eeb6b3e","view-QuestListDevelopmentResponsive":"650e11b4","view-QuestListInvestigationResponsive":"d081776d","view-QuestListResponsive":"cccaf3a1","component-DashboardNavigation":"aa31827c","component-DropdownList":"993afeb8","component-DropdownListSearch":"258acb58","component-setup-Step1":"77169499","component-setup-Step2":"1f4d7ec5","component-setup-Step3":"11b236a8","component-setup-Step4":"7b745339","component-setup-Step5":"d97d1997","component-HelloWorld":"940f12a9","component-MultiselectSearch":"dcdd1672","component-QuestListItem":"a4f8a8d5","component-QuestLog":"8641295d","component-QuestObjective":"e97a7898","component-QuestReward":"85a80b97","component-RandomChart":"3fe873a8","view-BadgeResponsive":"d7d2f150","view-LeaderboardResponsive":"cc7dc2b1","component-Tab":"9d04c91a","component-Tabs":"37c1842f","component-TimeLog":"1c1797a0","component-setup-Navigation":"6029df88","layout-DashboardLayout":"dd6911ce","layout-DashboardLayoutMenu":"abb488a7","layout-DefaultLayout":"120827fe","view-About":"8daa50ce","view-AchievementsResponsive":"ea3e074a","view-CMSResponsive":"14876cbb","view-Home":"edf42470","view-Leaderboard":"02caed07","view-NewBoardResponsive":"f6f043ae","view-NewCardResponsive":"de3f5074","view-NewCategoryResponsive":"6544e2e1","view-NewPlayerResponsive":"2dca8c83","view-NewQuestResponsive":"74d8e0d2","view-PageNotFound":"dfe3a5af","view-Profile":"1afd56a8","view-ProfileResponsive":"08000f49","view-QuestDetailsResponsive":"455eb11c","view-Quests":"216e6e43","view-Settings":"387bcd2d","view-SettingsResponsive":"52ddc976","view-Setup":"1b91a1f6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"component-Card":1,"component-CardDetails":1,"view-Dashboard":1,"layout-ResponsiveLayout":1,"view-DashboardResponsive":1,"view-ExploreResponsive":1,"component-DashboardNavigation":1,"component-DropdownList":1,"component-DropdownListSearch":1,"component-setup-Step1":1,"component-setup-Step2":1,"component-setup-Step3":1,"component-setup-Step4":1,"component-setup-Step5":1,"component-HelloWorld":1,"component-MultiselectSearch":1,"component-RandomChart":1,"view-BadgeResponsive":1,"layout-DashboardLayout":1,"view-Home":1,"view-Leaderboard":1,"view-NewCardResponsive":1,"view-PageNotFound":1,"view-Profile":1,"view-ProfileResponsive":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"component-Aside":"component-Aside","component-Card":"component-Card","component-CardDetails":"component-CardDetails","component-DropdownList~component-DropdownListSearch~component-setup-Step1~component-setup-Step2~comp~255f6546":"component-DropdownList~component-DropdownListSearch~component-setup-Step1~component-setup-Step2~comp~255f6546","view-Dashboard":"view-Dashboard","layout-ResponsiveLayout":"layout-ResponsiveLayout","view-DashboardResponsive":"view-DashboardResponsive","view-ExploreResponsive":"view-ExploreResponsive","view-QuestListBountyResponsive":"view-QuestListBountyResponsive","view-QuestListDevelopmentResponsive":"view-QuestListDevelopmentResponsive","view-QuestListInvestigationResponsive":"view-QuestListInvestigationResponsive","view-QuestListResponsive":"view-QuestListResponsive","component-DashboardNavigation":"component-DashboardNavigation","component-DropdownList":"component-DropdownList","component-DropdownListSearch":"component-DropdownListSearch","component-setup-Step1":"component-setup-Step1","component-setup-Step2":"component-setup-Step2","component-setup-Step3":"component-setup-Step3","component-setup-Step4":"component-setup-Step4","component-setup-Step5":"component-setup-Step5","component-HelloWorld":"component-HelloWorld","component-MultiselectSearch":"component-MultiselectSearch","component-QuestListItem":"component-QuestListItem","component-QuestLog":"component-QuestLog","component-QuestObjective":"component-QuestObjective","component-QuestReward":"component-QuestReward","component-RandomChart":"component-RandomChart","view-BadgeResponsive":"view-BadgeResponsive","view-LeaderboardResponsive":"view-LeaderboardResponsive","component-Tab":"component-Tab","component-Tabs":"component-Tabs","component-TimeLog":"component-TimeLog","component-setup-Navigation":"component-setup-Navigation","layout-DashboardLayout":"layout-DashboardLayout","layout-DashboardLayoutMenu":"layout-DashboardLayoutMenu","layout-DefaultLayout":"layout-DefaultLayout","view-About":"view-About","view-AchievementsResponsive":"view-AchievementsResponsive","view-CMSResponsive":"view-CMSResponsive","view-Home":"view-Home","view-Leaderboard":"view-Leaderboard","view-NewBoardResponsive":"view-NewBoardResponsive","view-NewCardResponsive":"view-NewCardResponsive","view-NewCategoryResponsive":"view-NewCategoryResponsive","view-NewPlayerResponsive":"view-NewPlayerResponsive","view-NewQuestResponsive":"view-NewQuestResponsive","view-PageNotFound":"view-PageNotFound","view-Profile":"view-Profile","view-ProfileResponsive":"view-ProfileResponsive","view-QuestDetailsResponsive":"view-QuestDetailsResponsive","view-Quests":"view-Quests","view-Settings":"view-Settings","view-SettingsResponsive":"view-SettingsResponsive","view-Setup":"view-Setup"}[chunkId]||chunkId) + "." + {"component-Aside":"31d6cfe0","component-Card":"66f92f02","component-CardDetails":"8774883c","component-DropdownList~component-DropdownListSearch~component-setup-Step1~component-setup-Step2~comp~255f6546":"31d6cfe0","view-Dashboard":"9273f679","layout-ResponsiveLayout":"ba43fe0c","view-DashboardResponsive":"5d2b66eb","view-ExploreResponsive":"dd911861","view-QuestListBountyResponsive":"31d6cfe0","view-QuestListDevelopmentResponsive":"31d6cfe0","view-QuestListInvestigationResponsive":"31d6cfe0","view-QuestListResponsive":"31d6cfe0","component-DashboardNavigation":"41000203","component-DropdownList":"f456f206","component-DropdownListSearch":"f456f206","component-setup-Step1":"e1ce81c7","component-setup-Step2":"bbb4d477","component-setup-Step3":"fdac6787","component-setup-Step4":"42fc6d18","component-setup-Step5":"92e09a59","component-HelloWorld":"b4e2214d","component-MultiselectSearch":"fa7650ea","component-QuestListItem":"31d6cfe0","component-QuestLog":"31d6cfe0","component-QuestObjective":"31d6cfe0","component-QuestReward":"31d6cfe0","component-RandomChart":"8333417b","view-BadgeResponsive":"72bf6b30","view-LeaderboardResponsive":"31d6cfe0","component-Tab":"31d6cfe0","component-Tabs":"31d6cfe0","component-TimeLog":"31d6cfe0","component-setup-Navigation":"31d6cfe0","layout-DashboardLayout":"41000203","layout-DashboardLayoutMenu":"31d6cfe0","layout-DefaultLayout":"31d6cfe0","view-About":"31d6cfe0","view-AchievementsResponsive":"31d6cfe0","view-CMSResponsive":"31d6cfe0","view-Home":"190c0aa5","view-Leaderboard":"ad865807","view-NewBoardResponsive":"31d6cfe0","view-NewCardResponsive":"3b726b41","view-NewCategoryResponsive":"31d6cfe0","view-NewPlayerResponsive":"31d6cfe0","view-NewQuestResponsive":"31d6cfe0","view-PageNotFound":"fc2a0753","view-Profile":"7a9c7294","view-ProfileResponsive":"010d788a","view-QuestDetailsResponsive":"31d6cfe0","view-Quests":"31d6cfe0","view-Settings":"31d6cfe0","view-SettingsResponsive":"31d6cfe0","view-Setup":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
